import { text_mod_87 } from "../text/Text.js";

export const module87 = {
  title: "План тексту",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_87,
    },
  ],
};
